import appStorage from'@baseext/shared/src/storage/appStorage';const v4appStorage=appStorage;export{v4appStorage};